import {
    type ApplicantCreationDto,
    ApplicantDto,
    ApplicantSharedWithRelationsDto,
    type ApplicantUpdateDto,
} from "@sr-partner-portal/common";
import { BaseApiService } from "./base-api-service";

export type UploadApplicantData = Omit<
    ConstructorParameters<typeof ApplicantCreationDto>[0],
    "jobPositionId" | "phaseId" | "sourceId" | "sourcePlatformId"
> & {
    phaseName: string;
    sourceName: string;
    sourcePlatformName: string;
    fileUrls: string[];
};

class ApplicantsApiService extends BaseApiService {
    async getByShareLinkToken(token: string) {
        const responseData = await this._apiHttpService.getAsync(
            this._apiRoutes()
                .applicants()
                .getByShareLinkToken(false, { token })
                .build(),
        );

        const applicantSharedWithRelationsDto =
            ApplicantSharedWithRelationsDto.createFromApplicantWithRelationsData(
                responseData.applicantSharedWithRelationsDto,
            );

        const applicantSharedWithRelations =
            applicantSharedWithRelationsDto.toApplicantWithRelations();
        return applicantSharedWithRelations;
    }

    async updateByShareLinkTokenAsync(
        token: string,
        applicantUpdateDto: ApplicantUpdateDto,
    ) {
        const responseData = await this._apiHttpService.putAsync(
            this._apiRoutes()
                .applicants()
                .updateByShareLinkToken(false, { token })
                .build(),
            {
                applicantUpdateDto,
            },
        );

        const applicantDto = ApplicantDto.createFromApplicantData(
            responseData.applicantDto,
        );
        const applicant = applicantDto.toApplicant();
        return applicant;
    }
}

export { ApplicantsApiService };
